<template>
  <div ref="chart">
    <Chart :height="height" :id="id" :option="option" :width="width" :extendData="extendData"></Chart>
  </div>
</template>

<script>
import Chart from '@/components/echarts/Chart';

export default {
  name: "LineChart",
  components: {Chart},
  props: {
    data: {},
    extendData: null,
  },
  data() {
    return {
      id: "lineChart",
      width: '100%',
      height: '100%',
      option: {},
    };
  },
  watch: {
    data() {
      this.getOption();
    }
  },
  mounted() {
    this.getOption()
  },
  methods: {
    getOption: function () {
      let labelColor = 'rgba(73, 164, 243, .2)';
      const colorList = ["rgba(16, 142, 233, 1)", 'rgba(50, 207, 210, 1)']
      this.option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            label: {
              show: false,
              backgroundColor: 'rgba(0,0,0,0)',
              color: '#556677',
              borderColor: 'rgba(0,0,0,0)',
              shadowColor: 'rgba(0,0,0,0)',
              shadowOffsetY: 0
            },
            lineStyle: {
              width: 0
            }
          },
          backgroundColor: 'rgba(0,0,0,0.5)',
          textStyle: {
            color: '#fff'
          },
          padding: [10, 10],
          extraCssText: 'box-shadow: 1px 0 2px 0 rgba(163,163,163,0.5)'
        },
        grid: {
          top: '10%',
          right: '15%',
          left: '15%',
          bottom: '20%'
        },
        xAxis: [{
          type: 'category',
          data: this.data.time,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0,
            textStyle: {
              color: '#fff'
            },
            // 默认x轴字体大小
            fontSize: 12,
            // margin:文字到x轴的距离
            margin: 15
          },
          boundaryGap: false
        }],
        yAxis: [{
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: colorList[0]
            },
            formatter: '{value}' + '℃'
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: labelColor
            }
          },
        },
          //Y轴右边显示 湿度
          {
            type: 'value',
            max: 70,
            min: 20,
            position: 'right',
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: colorList[1]
              },
              formatter: '{value}' + '%'
            },
            axisLine: {
              show: false,
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [{
          name: '温度',
          type: 'line',
          data: this.data.temperature,
          symbolSize: 1,
          symbol: 'circle',
          smooth: true,
          yAxisIndex: 0,
          showSymbol: false,
          lineStyle: {
            normal: {
              color: colorList[0],
            }
          },
          itemStyle: {
            normal: {
              color: colorList[0],
              borderColor: colorList[0]
            }
          }
        },
        //  湿度线条 区域
          {
          name: '湿度',
          type: 'line',
          data: this.data.humidity,
          symbolSize: 1,
          yAxisIndex: 1,
          symbol: 'circle',
          smooth: true,
          showSymbol: false,
          lineStyle: {
            normal: {
              color: colorList[1]
            }
          },
          itemStyle: {
            normal: {
              color: colorList[1],
              borderColor: colorList[1]
            }
          }
        }
        ]
      };
    },
  },
}
</script>

<style scoped>

</style>
